import Gallery from 'components/Gallery'
import { ItemImage } from 'components/Item/Image.js'
import { TopRightOverlay } from 'components/TopRightOverlay'
import { PRODUCT_MODEL_DATA_MEDIA_KEYS } from 'models/daos/product/constants'
import PropTypes from 'prop-types'
import React from 'react'
import {
  compactArrayUtil,
  pickObjectUtil
} from 'packages/src'

class ProductGallery extends React.Component {
  renderGallery () {
    const {
      data,
      image,
      name,
      title
    } = this.props

    const medias = compactArrayUtil([
      image,
      ...Object.values(
        pickObjectUtil(data, PRODUCT_MODEL_DATA_MEDIA_KEYS)
      )
    ])

    return (
      <Gallery
        name={title}
        onChangeSelectedIndex={this.props.onChangeSelectedIndex}
        selectedIndex={this.props.selectedImageIndex}
      >
        {medias.map((source, index) => (
          <ItemImage
            isBig
            aspectRatio={ItemImage.ASPECT_RATIO.TALL_HQ}
            key={index}
            source={source}
            title={title || name}
          />
        ))}
      </Gallery>
    )
  }

  renderDiscount () {
    const { discountPercentage } = this.props
    if (!discountPercentage) {
      return
    }
    return (
      <TopRightOverlay>
        <span>{this.props.discountPercentage}% off</span>
      </TopRightOverlay>
    )
  }

  renderLimitedEdition () {
    if (!this.props.isLimitedEdition) {
      return
    }
    return (
      <TopRightOverlay>
        <span>Limited Edition</span>
      </TopRightOverlay>
    )
  }

  render () {
    return (
      <div
        style={{
          position: 'relative'
        }}
      >
        {this.renderGallery()}
        {this.renderDiscount()}
        {this.renderLimitedEdition()}
      </div>
    )
  }
}

ProductGallery.propTypes = {
  discountPercentage: PropTypes.number.isRequired,
  selectedImageIndex: PropTypes.number,
  onChangeSelectedIndex: PropTypes.func,
  isLimitedEdition: PropTypes.bool,
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired
}

export default ProductGallery
